import classNames from 'classnames'
import { Tooltip as ReactTooltip } from 'react-tooltip'
import type { ITooltip as ReactTooltipProps } from 'react-tooltip'

import './Tooltip.scss'

export type TooltipSize = 'xs' | 's' | 'm'

export interface TooltipProps extends ReactTooltipProps {
  size?: TooltipSize
}

export const Tooltip: React.FC<TooltipProps> = ({
  className,
  noArrow = true,
  opacity = 1,
  size = 'm',
  delayShow = 500,
  delayHide = 0,
  place = 'bottom',
  ...tooltipProps
}) => (
  <ReactTooltip
    className={classNames('m-tooltip', `m-tooltip--${size}`, className)}
    noArrow={noArrow}
    opacity={opacity}
    delayShow={delayShow}
    delayHide={delayHide}
    place={place}
    {...tooltipProps}
  />
)
